let state = {
  vaccine: null,
  vaccines: {
    links: {
      total: 0,
      per_page: 0,
      current_page: "1",
      last_page: 0,
      next_page_url: null,
      prev_page_url: null,
      from: 0,
      to: 0
    },
    results: []
  }
};

export default state;
